/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ChannelKind {
  Custom = 'Custom',
  Timeslots = 'Timeslots',
  DropIn = 'DropIn',
  Messaging = 'Messaging',
  RedRobin = 'RedRobin',
  Navigation = 'Navigation'
}
